<template>
  <div class="layout">
    <layout-head />
    <layout-main />
    <layout-footer />
  </div>
</template>

<script>
import LayoutHead from '@/layout/components/LayoutHead/index.vue'
import LayoutFooter from '@/layout/components/LayoutFooter/index.vue'
import LayoutMain from '@/layout/components/LayoutMain.vue'
export default {
  name: 'Layout',
  components: {
    LayoutHead,
    LayoutFooter,
    LayoutMain,
  },

  props: {},
  data() {
    return {}
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/variables.scss';
.layout {
  width: 100%;
  height: 100%;
  background-color: #f8f8f8;
  position: relative;
}
</style>
